import React from 'react'
import PropTypes from 'prop-types'
import { Marker } from 'react-map-gl'

import MapPin from '../../../../assets/map-pin.svg'

const SIZE = 35

export const Pins = React.memo(({ data, onClick = () => {} }) => {
  return data.map(restaurant => {
    const { location, guid } = restaurant
    const { latitude, longitude } = location
    return (
      <Marker key={guid} longitude={longitude} latitude={latitude}>
        <MapPin
          data-testid='map-pin'
          height={SIZE}
          style={{
            cursor: 'pointer',
            transform: `translate(${-SIZE / 2}px,${-SIZE}px)`
          }}
          onClick={() => onClick(restaurant)}
        />
      </Marker>
    )
  })
})

Pins.propTypes = {
  data: PropTypes.array.isRequired,
  onClick: PropTypes.func
}
